import React from "react";
import NavBar from "../../components/NavBar";
import Footer from "../../components/SessionFooter";
import CountButton from "../../components/CountButton";
import './tailinjury.scss';
import {NextIcon} from '../../components/Icons';

import { useHistory } from "react-router-dom";
import { AppContext } from '../../AppContext';

const TailInjury: React.SFC<{}> = () => {
  const context = React.useContext(AppContext);
  let state = context.state;
  let history = useHistory();

  const [highMildCount, setHighMildCount] = React.useState(0);
  const [highSevereCount, setHighSevereCount] = React.useState(0);

  const [middleMildCount, setMiddleMildCount] = React.useState(0);
  const [middleSevereCount, setMiddleSevereCount] = React.useState(0);

  const [lowMildCount, setLowMildCount] = React.useState(0);
  const [lowSevereCount, setLowSevereCount] = React.useState(0);

  const [active, setActive] = React.useState(false);

  const [notActiveCss, setNotActiveCss] = React.useState("rpg_button active");
  const [isActiveCss, setIsActiveCss] = React.useState("rpg_button");

  let highMildDisabled = false;
  let highSeveredDisabled = false;

  let middleMildDisabled = false;
  let middleSeveredDisabled = false;

  let lowMildDisabled = false;
  let lowSeveredDisabled = false;

  
  switch(state.current.dockedPosition)
  {
    case 'low':
      break;
    case 'middle':
      lowMildDisabled = true;
      lowSeveredDisabled = true;
      break;
    case 'high':
      middleMildDisabled = true;
      middleSeveredDisabled = true;
      lowMildDisabled = true;
      lowSeveredDisabled = true;
      break;
    default:
      break;
  }


  const highMildCountHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setHighMildCount((highMildCount >= 2) ? 2 : (highMildCount + 1));
  }

  const highSevereCountHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setHighSevereCount((highSevereCount >= 2) ? 2 : (highSevereCount + 1));
  }

  const middleMildCountHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setMiddleMildCount((middleMildCount >= 2) ? 2 : (middleMildCount + 1));
  }

  const middleSevereCountHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setMiddleSevereCount((middleSevereCount >= 2) ? 2 : (middleSevereCount + 1));
  }
  
  const lowMildCountHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setLowMildCount((lowMildCount >= 2) ? 2 : (lowMildCount + 1));
  }

  const lowSevereCountHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setLowSevereCount((lowSevereCount >= 2) ? 2 : (lowSevereCount + 1));
  }

  const hasActiveHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setActive(true);
    setNotActiveCss("rpg_button");
    setIsActiveCss("rpg_button active");
  }

  const noActiveHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setActive(false);
    setNotActiveCss("rpg_button active");
    setIsActiveCss("rpg_button");
  }

  const backHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    state.current.dockedPosition = "";
    context.setState(state);
    history.goBack();
  }

  const nextHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    state.current.highMildCount = highMildCount;
    state.current.highSevereCount = highSevereCount;
    state.current.midMildCount = middleMildCount;
    state.current.midSevereCount = middleSevereCount;
    state.current.lowMildCount = lowMildCount;
    state.current.lowSevereCount = lowSevereCount;
    state.current.activeInjury = active;
    context.setState(state);
    history.push('/receipt');
  }


  const resetHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setHighMildCount(0);
    setHighSevereCount(0);
    setMiddleMildCount(0);
    setMiddleSevereCount(0);
    setLowMildCount(0);
    setLowSevereCount(0);
    setActive(false);
    setNotActiveCss("rpg_button active");
    setIsActiveCss("rpg_button");
  }

    return (
      <>
        <NavBar
          backBtnTitle="Back"
          backBtnClick={backHandler}
          actionBtnTitle="Reset"
          actionBtnClick={resetHandler}
          tag={context.state.current.tagNumber}
        />
        <h1>Injuries to the tail</h1>
        <div className="content-pane">
          <div className="injury-buttons">
            <div className="title-high align-center">High</div>
            <div className="title-middle align-center">Middle</div>
            <div className="title-lower align-center">Lower</div>
            <div className="title-mild align-center">Mild</div>
            <div className="title-severe align-center">Severe</div>
            <div className="button-high-mild">
              <CountButton 
                count={highMildCount}  
                onClick={highMildCountHandler} 
                disabled={highMildDisabled} /></div>
            <div className="button-high-severe">
              <CountButton 
                count={highSevereCount} 
                onClick={highSevereCountHandler}
                disabled={highSeveredDisabled} /></div>
            <div className="button-middle-mild">
              <CountButton 
                count={middleMildCount} 
                onClick={middleMildCountHandler}
                disabled={middleMildDisabled} /></div>
            <div className="button-middle-severe">
              <CountButton 
                count={middleSevereCount} 
                onClick={middleSevereCountHandler} 
                disabled={middleSeveredDisabled} /></div>
            <div className="button-lower-mild">
              <CountButton 
                count={lowMildCount} 
                onClick={lowMildCountHandler} 
                disabled={lowMildDisabled}/></div>
            <div className="button-lower-severe">
              <CountButton
                count={lowSevereCount} 
                onClick={lowSevereCountHandler}
                disabled={lowSeveredDisabled} /></div>
            <hr className="divider" />
            <div className="title-active">Active Injury</div>
            <div className="button-active-false toggle"><button className={notActiveCss} onClick={noActiveHandler}>No</button></div>
            <div className="button-active-true toggle"><button className={isActiveCss} onClick={hasActiveHandler}>Yes</button></div>
            <button className="button-next rpg_button action"  onClick={nextHandler}>NEXT <NextIcon fill="#FFFFFF" /></button>
          </div>
        </div>
        <Footer tag={state.previous.tagNumber} />
      </>
     )
  }



export default TailInjury;

